<template>
  <div  :class="{ 'PAST': isDimmedAppointment }">
    <div class="p-b-2">{{appointmentPurpose(appointment.purpose)}}</div>
    <div class="d-flex">
      <vk-icon
          name="simple-clock"
          class="MODAL-ICON p-r-1"/>
      <div>
        <div>{{formatDate(appointment.start_dtm)}}</div>
        <div>{{formatDate(appointment.end_dtm)}}</div>
      </div>
    </div>
  </div>
</template>

<script>

import { isBefore, format } from 'date-fns';
import { PURPOSES_MAP } from '@/constants/appointments';

export default {
  name: 'history-appointment',
  props: {
    appointment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isDimmedAppointment () {
      return isBefore(new Date(this.appointment.end_dtm), Date.now());
    },
  },
  methods: {
    appointmentPurpose (purpose) {
      return PURPOSES_MAP[purpose].long;
    },
    formatDate (date) {
      return format(new Date(date), 'eeee MMM dd yyyy h:mm a');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

  .MODAL-ICON {
      @include h4;
      color: $color-gray60;
  }
  .PAST {
    color: $color-gray40 !important;
  }
</style>
